export const PromptSVG: React.FC = (params: any) => {
    return (
        <svg fill="currentColor" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 5.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5Zm0 3c0-.28.22-.5.5-.5h11.08c-.6 0-1.15.36-1.38.92l-.03.08H2.5a.5.5 0 0 1-.5-.5Zm8.09 5.5c-.12.34-.11.7 0 1H2.5a.5.5 0 0 1 0-1h7.59Zm.83-2H2.5a.5.5 0 0 1 0-1h8.83l-.41 1Zm.58 3h1.75l-.59 2.36c-.12.48.46.83.83.49l4.87-4.55a.75.75 0 0 0-.51-1.3h-1.1l.78-2.34a.5.5 0 0 0-.47-.66h-3.47a.5.5 0 0 0-.47.3l-2.08 5c-.14.34.1.7.46.7Z" fill="currentColor">
            </path>
        </svg>
    );
};